// Auto generated file, do not manually modify!
// com.hotpads.hotpadsapi.enums.SearchEmailFrequency

export enum SearchEmailFrequency {
  DAILY = 'daily',
  EVERY_2_DAYS = 'every_2_days',
  EVERY_30_DAYS = 'every_30_days',
  EVERY_4_DAYS = 'every_4_days',
  HOURLY = 'hourly',
  NEVER = 'never',
  TWICE_DAILY = 'twice_daily',
  WEEKLY = 'weekly',
}

export const SearchEmailFrequency_values = [
  SearchEmailFrequency.DAILY,
  SearchEmailFrequency.EVERY_2_DAYS,
  SearchEmailFrequency.EVERY_30_DAYS,
  SearchEmailFrequency.EVERY_4_DAYS,
  SearchEmailFrequency.HOURLY,
  SearchEmailFrequency.NEVER,
  SearchEmailFrequency.TWICE_DAILY,
  SearchEmailFrequency.WEEKLY,
] as const;
